import { useTranslation } from 'react-i18next'

import { FailedIcon } from '@arcade/web/icons/react'
import { ArcadePageHeader, Button, IconMat, spacing, Stack } from '@cash-design-system/react'

const goToSupport = () => {
  window.open('/support', '_blank')
}

export const ModalErrorContent = ({
  title,
  message,
  showSupportButton = true,
}: {
  title?: string
  message?: string
  showSupportButton?: boolean
}) => {
  const { t } = useTranslation()

  return (
    <Stack space={spacing.xxl}>
      <ArcadePageHeader
        asset={{
          avatar: (
            <IconMat variant="danger">
              <FailedIcon size={32} />
            </IconMat>
          ),
        }}
        title={title ?? t('Something went wrong', { context: 'modal title' })}
        titleElement="h1"
        body={message ?? t('Try again or contact support.', { context: 'modal body text' })}
      />
      {showSupportButton && (
        <Button size="large" variant="secondary" onClick={goToSupport}>
          {t('Contact Support', { context: 'button text' })}
        </Button>
      )}
    </Stack>
  )
}
